// extracted by mini-css-extract-plugin
module.exports = {"taskRow":"Home2TasksCard_taskRow__IT8CK","taskTitle":"Home2TasksCard_taskTitle__Jt00q","done":"Home2TasksCard_done__6_NAx","groupLink":"Home2TasksCard_groupLink__GtWoW"};